module.exports = __webpack_public_path__ + "img/empty_table_illustration.8eb3e1f2.png";